import { SettingOutlined } from '@ant-design/icons'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import DoughnuttCardV3 from '../userManagementV2/local components/doughnuttCardV3';
import { Button } from 'components/Button';
import { DatePicker } from 'antd';
import { FiChevronDown } from 'react-icons/fi';
import ReportDrawer from './localComponent/reportDrawer';
import { connect } from 'react-redux';
import { storeEndDate, storeSelectedRange, storeStartDate, usersDownloadReport } from 'actions/attendanceNew';
import { setSpecificUserId } from 'actions/userManagement';
import { downloadAttendanceBySchedule, getAttendanceOverview, getAttendanceRequests } from 'actions/profileNew';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { TimeSheetGraph } from './localComponent/timeSheetGraph';
import CustomTable from 'components/customTable';
import './userProfileAttendanceDetailsV3.css'
import MarkAttendanceDrawer from './localComponent/markAttendanceDrawer';
import SettingsDrawer from './localComponent/settingsDrawer';
import FilterComponent from './localComponent/filterComponent';
import AttendanceRequestTable from './localComponent/attendanceRequestTable';
import AttendanceRequestsModal from 'pages/profile/attendanceRequestsModal';
import TableComponent from '../profile/attendanceBySchecduleTable';


const UserAttendanceTabV3 = ({ startDateContainer, selectedRangeContainer, endDateContainer, storeSelectedRange, storeStartDate,
    storeEndDate, usersDownloadReport, specificUserProfile, setSpecificUserId, getAttendanceOverview, setPageLoader, attendanceOverview,
    getAttendanceRequests, attendanceRequests, user, downloadAttendanceBySchedule }) => {
    // const settingsIcon = require('../../Assets/userManagementV3/Settings.png').default
    const overAllPercent = attendanceOverview?.overview?.overallPercentage;

    const overViewData = [
        {
            type: 'Present',
            value: attendanceOverview?.overview?.PresentCount,
        },
        {
            type: 'Absent',
            value: attendanceOverview?.overview?.AbsentCount,
        },

        {
            type: 'Leave',
            value: attendanceOverview?.overview?.totalLeaves,
        }
    ];
    console.log({ attendanceOverview });

    const location = useLocation();

    const [isYear1, setIsYear1] = useState(moment().format('YYYY'))
    const [isMonth1, setIsMonth1] = useState(moment().format('MMM'))


    const [drawerVisible, setDrawerVisible] = useState(false);
    const [settingsDrawerVisible, setSettingsDrawerVisible] = useState(false);
    const [markDrawerVisible, setMarkDrawerVisible] = useState(false);
    const [timeSheetMonth, setTimeSheetMonth] = useState(moment().format("MMMM"))
    const [timeSheetYear, setTimeSheetYear] = useState(moment().format('YYYY'));
    const [scheduleMonth, setScheduleMonth] = useState(moment().format("MMMM"))
    const [scheduleYear, setScheduleYear] = useState(moment().format("YYYY"))
    const [filter, setFilter] = useState({
        page: 1,
        limit: 10
    })
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [attendanceFormDetails, setAttendanceFormDetails] = useState({
        date: null,
        clockIn: null,
        clockOut: null,
        totalHours: null,
        reason: null
    })
    const [year, setYear] = useState(moment().year());
    const [month, setMonth] = useState(moment().month() + 1);
    const [range, setRange] = useState([moment().startOf('week'), moment().endOf('week')]);
    const [isChecked, setIsChecked] = useState(false)
    const [isChecked1, setIsChecked1] = useState(false)
    const [durationSettings, setDurationSettings] = useState({ duration: 'Permanent', startDate: '', endDate: '' })
    const [attRequestModal, setAttRequestModal] = useState(false);
    const [storeRowData, setStoreRowData] = useState(null)
    const options = [
        { label: 'Days', value: 'days' },
        { label: 'Months', value: 'month' },
        { label: 'Years', value: 'year' },
    ];

    const [selectedOption, setSelectedOption] = useState(options[0]?.value);
    const [isMonthSelection, setIsMonthSelection] = useState(false);
    const handleMonthChange = (value) => {
        if (!value) return;
        setIsMonthSelection(true);
        setMonth(value.month() + 1);
    };

    const AttendanceTimeSheetParams = {
        type: selectedOption, // Access the `value` property of `selectedOption`
        startDate: moment(range[0]).format('DD-MMM'),
        endDate: moment(range[1]).format('DD-MMM'),
        month: month,
        year: year
    };

    console.log("AttendanceTimeSheetParams", AttendanceTimeSheetParams);


    console.log({ attendanceRequests });
    const pageSuccessCallback = () => {
        setPageLoader(true)
        getAttendanceRequests({
            userId: specificUserProfile?.id,
            ...filter
        }, () => setPageLoader(false))
    }

    useEffect(() => {
        setPageLoader(true)
        getAttendanceRequests({
            userId: specificUserProfile?.id,
            year: isYear1,
            month: isMonth1,
            ...filter
        }, () => setPageLoader(false))
    }, []);

    useEffect(() => {
        setPageLoader(true)
        getAttendanceRequests({
            userId: specificUserProfile?.id,
            year: isYear1,
            month: isMonth1,
            ...filter
        }, () => setPageLoader(false))
    }, [filter, isYear1, isMonth1]);

    useEffect(() => {
        setSpecificUserId(specificUserProfile?.id)
    }, [])

    const today = new Date();
    const firstDateOfYear = new Date(today.getFullYear(), 0, 1);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const getOverviewParams = () => {
        const params = {
            userId: specificUserProfile?.id,
            attendanceByScheduleYear: scheduleYear,
        };

        if (selectedOption === 'days') {
            params.since = formatDate(range[0].toDate ? range[0].toDate() : range[0]);
            params.tillDate = formatDate(range[1].toDate ? range[1].toDate() : range[1]);
            params.attendanceByScheduleMonth = scheduleMonth;
            params.attendanceByTimesheetMonth = moment(`${year}-${month}`, 'YYYY-M').format('MMMM');
            params.attendanceByTimesheetYear = year.toString();
        } else if (selectedOption === 'month') {
            // params.attendanceByTimesheetMonth = moment(`${year}-${month}`, 'YYYY-M').format('MMMM');
            params.attendanceByTimesheetYear = year.toString();
        } else if (selectedOption === 'year') {
            params.attendanceByTimesheetYear = year.toString();
        }

        return params;
    };

    useEffect(() => {
        setPageLoader(true);
        getAttendanceOverview(getOverviewParams(), () => setPageLoader(false));
    }, [selectedOption, year, month, range, scheduleMonth, scheduleYear, specificUserProfile?.id]);

    const showDrawer = () => {
        setDrawerVisible(true);
    };
    const showMarkDrawer = () => {
        setMarkDrawerVisible(true);
    };
    const showSettingsDrawer = () => {
        setSettingsDrawerVisible(true);
    };

    const onRow = (record, rowIndex) => {
        return {
            style: { cursor: 'pointer' },
            onClick: (e) => {
            }
        }
    }
    const rowSelection = {
        type: "checkbox",
        selectedRowKeys: selectedRowKeys,
        onChange: (selectedRowKeys, selections) => {
            setSelectedRowKeys([...selectedRowKeys]);
        },
    };

    const formatTime = (time) => {
        const [hours, minutes] = time.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);

        let hours12 = date.getHours() % 12 || 12;
        let ampm = date.getHours() >= 12 ? 'PM' : 'AM';

        return `${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    };

    const formatClockInOut = (clockIn, clockOut) => {
        return `${formatTime(clockIn)} - ${formatTime(clockOut)}`;
    };

    const yesterday1 = moment().subtract(1, 'days').format('DD/MM/YYYY');


    const attendanceByScheduleOnPress = () => {
        let params = {
            attendanceDetailsMonth: scheduleMonth,
            attendanceByScheduleYear: timeSheetYear,
        }
        setSpecificUserId(specificUserProfile?.id)
        downloadAttendanceBySchedule(params);
    }
    const handleLeftClick = () => {
        const newStartDate = range[0].clone().subtract(7, 'days');
        const newEndDate = range[1].clone().subtract(7, 'days');
        setRange([newStartDate, newEndDate]);
    };

    const handleRightClick = () => {
        const newStartDate = range[0].clone().add(7, 'days');
        const newEndDate = range[1].clone().add(7, 'days');
        setRange([newStartDate, newEndDate]);
    };
    const isCurrentWeek = range[0].isSame(moment(), "week");
    useEffect(() => {
        if (selectedOption === "days") {
            setScheduleMonth(moment(range[0]).format("MMMM"));
            setScheduleYear(moment(range[0]).format("YYYY"));
            setTimeSheetMonth(moment(range[0]).format("MMMM"));

            setMonth(moment(range[0]).month() + 1);
            setYear(moment(range[0]).year());
        }
    }, [range, selectedOption]);
    useEffect(() => {

    if (selectedOption !== "days") return;

    if (!isMonthSelection) return;

    const today = moment();

    let start;
    let end;

    if (
        month === today.month() + 1 &&
        year === today.year()
    ) {
        start = today.clone().startOf("week");
        end = today.clone().endOf("week");
    } else {
        start = moment({
            year,
            month: month - 1,
            date: 1,
        }).startOf("week");

        end = start.clone().add(6, "days");
    }

    setRange([start, end]);

    setScheduleMonth(start.format("MMMM"));
    setScheduleYear(start.format("YYYY"));

    setIsMonthSelection(false);

}, [month, year]);

    return (
        <div className='tab-container'>
            <div className='attendance-partition'>
                <div className='attendance-left-part'>
                    <div className='centered-flex-v3'>
                        <div className='sumary-text-style-v3'>Overview <span className='overview-text-style-v3'>(till {yesterday1})</span></div>
                        <div><SettingOutlined onClick={showSettingsDrawer} className='setting-style-v3'
                        /></div>
                    </div>
                    <div className='full-width-margin-top-v3'><DoughnuttCardV3 data={overViewData} percentage={overAllPercent} /> </div>
                    <div className='flex-center-v3'>
                        <div className='flex-margin-gap-v3'>
                            <div className='custom-background-v3'>
                                <div style={{ fontSize: 16, fontWeight: 600 }}>{attendanceOverview?.overview?.totalWorkingHoursTillDate}</div>
                                <div>total working hours</div>
                            </div>
                            <div className='custom-background-v3'>
                                <div style={{ fontWeight: 600, fontSize: 16 }}>{attendanceOverview?.overview?.averageWorkingHoursTillDate}</div>
                                <div>avg. working hours</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div style={{ height: '100%', width: '65%' }}>
                    <div className='attendance-right-part'>
                        <div className='sumary-text-style-v3'>Attendance summary</div>
                        <Button type="link" style={{ fontSize: 14 }} onClick={showDrawer}>
                            DOWNLOAD REPORT
                        </Button>
                    </div>
                    <div className='attendance-summary-v3'>
                        <div className='summary-first-card'>
                            <div>
                                <div className='bold-text-v3'>{attendanceOverview?.attendanceByTimesheet?.presentDays}</div>
                                <div className='grey-color-v3'> present days</div>
                            </div>
                        </div>
                        <div className='summary-other-cards'>
                            <div>
                                <div className='bold-text-v3'>{attendanceOverview?.attendanceByTimesheet?.absentDays}</div>
                                <div className='grey-color-v3'>absent days</div>
                            </div>
                        </div>
                        <div className='summary-other-cards'>
                            <div>
                                <div className='bold-text-v3'>{attendanceOverview?.attendanceByTimesheet?.halfDays}</div>
                                <div className='grey-color-v3'>half days</div>
                            </div>
                        </div>
                        <div className='summart-last-card'>
                            <div>
                                <div className='bold-text-v3'>{attendanceOverview?.attendanceByTimesheet?.totalWorkingHoursTillDate}</div>
                                <div className='grey-color-v3'>total working hours</div>
                            </div>
                        </div>
                        <div className='avg-working-card'>
                            <div>
                                <div className='bold-text-v3'>{attendanceOverview?.attendanceByTimesheet?.averageWorkingHoursTillDate}</div>
                                <div className='grey-color-v3'>avg. working hours</div>
                            </div>
                        </div>
                    </div>
                    <div className='attendnce-date-container'>
                        <div className='flex-end-v3'>
                            {console.log("rangerange", moment(range[0]).format('DD-MMM'), range[1])}
                            <FilterComponent
                                year={year}
                                month={month}
                                range={moment(range[0]).format('DD-MMM')}
                                range1={moment(range[1]).format('DD-MMM')}
                                setYear={setYear}
                                setMonth={setMonth}
                                setRange={setRange}
                                handleLeftClick={handleLeftClick}
                                handleRightClick={handleRightClick}
                                selectedOption={selectedOption}
                                setSelectedOption={setSelectedOption}
                                options={options}
                                joiningYear={year}
                                isCurrentWeek={isCurrentWeek}
                                onMonthChange={handleMonthChange}
                            />
                        </div>
                        <div style={{ height: '31vh', width: '100%', padding: 20 }}>
                            <TimeSheetGraph attendanceOverview={attendanceOverview || []} selectedOption={selectedOption} startDate={range[0]} endDate={range[1]} />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className=''></div> */}
            <div style={{  padding: '30px 30px 20px 30px' }}>
                <div className='att-request-filters'>
                    <div className='sumary-text-style-v3'>Attendance Requests</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '35%' }}>
                        <div ><DatePicker
                            className='rounded-date-picker-v3'
                            allowClear={false}
                            picker="year"
                            value={moment(isYear1)}
                            suffixIcon={<FiChevronDown className="custom-icon" />}
                            onChange={(date, dateString) => {
                                setIsYear1(moment(date).format('YYYY'))

                            }}
                        />
                        </div>
                        <div>
                            <DatePicker
                                className='rounded-date-picker-v3'
                                allowClear={false}
                                picker="month"
                                format={'MMM'}
                                value={moment(isMonth1, 'MMM')}
                                suffixIcon={<FiChevronDown className="custom-icon" />}
                                onChange={(date, dateString) => {
                                    setIsMonth1(moment(date).format('MMM'))
                                }} />
                        </div>
                        <div>
                            <Button type="primary" onClick={showMarkDrawer}>
                                MARK ATTENDANCE
                            </Button>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <AttendanceRequestTable
                        dataSource={attendanceRequests?.items || []}
                        setAttRequestModal={setAttRequestModal}
                        setStoreRowData={setStoreRowData}
                        storeRowData={storeRowData}
                    />
                </div>
            </div>
            <div style={{ padding: 30 }}>
                <div className='att-schedule-flex-container'>
                    <div className='sumary-text-style-v3'>Attendance by schedule</div>
                    <div className='att-schedule-filters'>
                        <div ><DatePicker
                            className='rounded-date-picker-v3'
                            allowClear={false}
                            picker="year"
                            value={moment(timeSheetYear)}
                            suffixIcon={<FiChevronDown className="custom-icon" />}
                            onChange={(date, dateString) => {
                                setTimeSheetYear(moment(date).format('YYYY'))

                            }}
                        />
                        </div>
                        <div>
                            <DatePicker
                                className='rounded-date-picker-v3'
                                allowClear={false}
                                picker="month"
                                format={'MMM'}
                                value={moment(scheduleMonth, 'MMM')}
                                suffixIcon={<FiChevronDown className="custom-icon" />}
                                onChange={(date, dateString) => {
                                    setScheduleMonth(moment(date).format('MMM'))
                                }} />
                        </div>
                        <div>
                            <Button type="link" style={{ fontSize: 14 }} onClick={() => attendanceByScheduleOnPress()}>
                                DOWNLOAD REPORT
                            </Button>
                        </div>
                    </div>
                </div>
                {console.log("attendanceOverview", attendanceOverview)}
                <TableComponent tableData={(user?.role?.includes('Student')) ? attendanceOverview?.attendanceDetails : attendanceOverview?.attendanceDetailsByClass || []} />
            </div>
            <ReportDrawer
                drawerVisible={drawerVisible}
                setDrawerVisible={setDrawerVisible}
                startDateContainer={startDateContainer}
                endDateContainer={endDateContainer}
                selectedRangeContainer={selectedRangeContainer}
                storeStartDate={storeStartDate}
                storeEndDate={storeEndDate}
                storeSelectedRange={storeSelectedRange}
                usersDownloadReport={usersDownloadReport}
            />
            <MarkAttendanceDrawer
                markDrawerVisible={markDrawerVisible}
                setMarkDrawerVisible={setMarkDrawerVisible}
                setAttendanceFormDetails={setAttendanceFormDetails}
                attendanceFormDetails={attendanceFormDetails}
                userId={specificUserProfile?.id}
            />

            <SettingsDrawer
                settingsDrawerVisible={settingsDrawerVisible}
                setSettingsDrawerVisible={setSettingsDrawerVisible}
                userId={specificUserProfile?.id}
                isChecked={isChecked}
                isChecked1={isChecked1}
                setIsChecked={setIsChecked}
                setIsChecked1={setIsChecked1}
                durationSettings={durationSettings}
                setDurationSettings={setDurationSettings}
            />

            {attRequestModal &&
                <AttendanceRequestsModal
                    open={attRequestModal}
                    onClose={() => setAttRequestModal(false)}
                    data={storeRowData}
                    successCallback={pageSuccessCallback}
                    setStoreRowData={setStoreRowData}
                />
            }

        </div>
    )
}

const mapStateToProps = (state) => {
    const { startDateContainer, selectedRangeContainer, endDateContainer, } = state.attendanceNew;
    const { attendanceOverview, attendanceRequests } = state.profileNew;
    const { user } = state.session;
    return {
        startDateContainer, selectedRangeContainer, endDateContainer, user, attendanceOverview, attendanceRequests
    };
};

const mapDispatchToProps = (dispatch) => ({
    storeStartDate: (val) => dispatch(storeStartDate(val)),
    storeEndDate: (val) => dispatch(storeEndDate(val)),
    storeSelectedRange: (val) => dispatch(storeSelectedRange(val)),
    usersDownloadReport: (callback, successCallBack) => (dispatch(usersDownloadReport(callback, successCallBack))),
    setSpecificUserId: (val) => dispatch(setSpecificUserId(val)),
    getAttendanceOverview: (params, callback) => dispatch(getAttendanceOverview(params, callback)),
    getAttendanceRequests: (params, callback) => dispatch(getAttendanceRequests(params, callback)),
    downloadAttendanceBySchedule: (params) => dispatch(downloadAttendanceBySchedule(params)),

});

export default connect(mapStateToProps, mapDispatchToProps)(UserAttendanceTabV3);
